var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "portlet-body" },
      [
        _c(
          "DxDataGrid",
          {
            ref: _vm.dataGridRefName,
            attrs: {
              id: "movimentacoes",
              "show-borders": true,
              "data-source": _vm.dataSource,
              "column-min-width": 100,
              "key-expr": "Handle",
              "on-cell-prepared": _vm.onCellPrepared,
              "no-data-text": "Sem movimentações",
            },
            scopedSlots: _vm._u([
              {
                key: "masterDetailTemplate",
                fn: function (ref) {
                  var data = ref.data
                  return [
                    _c("DetailTemplate", {
                      attrs: { "template-data": data.data },
                    }),
                  ]
                },
              },
            ]),
          },
          [
            _c("DxSorting", {
              attrs: {
                "ascending-text": "Ordem crescente",
                "descending-text": "Ordem descrescente",
                "clear-text": "Limpar ordenação",
              },
            }),
            _vm._v(" "),
            _c("DxExport", { attrs: { enabled: true, texts: _vm.texts } }),
            _vm._v(" "),
            _c(
              "DxFilterRow",
              {
                attrs: {
                  visible: _vm.showFilterRow,
                  "reset-operation-text": "Resetar",
                },
              },
              [
                _c("DxOperationDescriptions", {
                  attrs: {
                    between: "Entre",
                    contains: "Contém",
                    "ends-with": "Termina com",
                    equal: "É igual a",
                    "greater-than": "Maior que",
                    "greater-than-or-equal": "Maior que ou igual a",
                    "less-than": "Menor que",
                    "less-than-or-equal": "Menor que ou igual a",
                    "not-contains": "Não contém",
                    "not-equal": "Não é igual a",
                    "starts-with": "Começa com",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("DxHeaderFilter", {
              attrs: { visible: _vm.showHeaderFilter, texts: _vm.texts },
            }),
            _vm._v(" "),
            _c("DxSearchPanel", {
              attrs: { visible: true, width: 240, placeholder: "Procurar..." },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { width: 70, "data-field": "Status", caption: "Status" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                width: 125,
                caption: "Data/Hora",
                "data-field": "DataHora",
                "data-type": "datetime",
                format: "dd/MM/yyyy HH:mm",
                "allow-filtering": false,
                "allow-header-filtering": true,
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                caption: "Almox. destino",
                "data-field": "AlmoxDestino",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                width: 100,
                caption: "Tipo mov.",
                "data-field": "TipoMovimentacao",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                width: 100,
                caption: "Quantidade",
                "data-field": "Quantidade",
                format: _vm.decimalFormat,
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                "data-field": "SaldoAnterior",
                caption: "Saldo anterior",
                format: _vm.decimalFormat,
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                "data-field": "SaldoAtual",
                caption: "Saldo atual",
                format: _vm.decimalFormat,
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { "data-field": "Documento", caption: "Documento" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                "data-field": "CentroCusto",
                caption: "Centro de custo",
              },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { width: 80, "data-field": "Projeto", caption: "Projeto" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { "data-field": "AlmoxOrigem", caption: "Almox. origem" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { width: 80, "data-field": "Ordem", caption: "Ordem" },
            }),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: {
                "data-field": "ValorUnitario",
                caption: "Valor unitário",
                format: _vm.moedaFormat,
                precision: 4,
              },
            }),
            _vm._v(" "),
            _c(
              "DxColumn",
              {
                attrs: {
                  "data-field": "ValorTotal",
                  caption: "Valor total",
                  format: _vm.moedaFormat,
                },
              },
              [
                _c("DxHeaderFilter", {
                  attrs: { "data-source": _vm.valorTotalHeaderFilter },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("DxColumn", {
              attrs: { caption: "Pessoa", "data-field": "Pessoa" },
            }),
            _vm._v(" "),
            _vm.controlaLote
              ? _c("DxMasterDetail", {
                  attrs: { enabled: true, template: "masterDetailTemplate" },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c(
          "span",
          { staticClass: "caption-subject font-green-sharp bold uppercase" },
          [_vm._v("\n          Movimentações\n        ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }